import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-xhr-backend';

i18n
  .use(LanguageDetector)
  .use(Backend)
  .init(
    {
      fallbackLng: 'en',

      // have a common namespace used around the full app
      ns: ['common'],
      defaultNS: 'common',

      interpolation: {
        escapeValue: false, // not needed for react!!
        formatSeparator: ',',
      },

      react: {
        wait: true,
      },
      whitelist: ['en'],
    },
    (err, t) => {
      if (err) return console.error('something went wrong loading', err);
    }
  );

export default i18n;
